// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerColor":"Footer_footerColor__ceBVI","footerContent":"Footer_footerContent__QyXXU","cat":"Footer_cat__-oA6k"};